import { useThree } from "@react-three/fiber";
import { useEffect, useMemo } from "react";
import { findObjectStartsWithKey } from "../../../utils/FindObjects";

import fragmentShaderReplacement from "../shader/VertexColorHeat_replacement.glsl";
import fragmentShaderAddition from "../shader/VertexColorHeat_addition.glsl";
import { PointLight, Color, Vector3 } from "three";
import { useLayoutEffect } from "react";
import { useRef } from "react";
import { useSpring, config as springConfig } from "@react-spring/three";
import { useEbbne } from "@solidwhite/ebbnen";

const LightName = "Brazing_light_qweqweqw";

const Brazing = ({ ...props }) => {
  const { active } = useEbbne();
  const glowing = active;

  const materialRef = useRef();
  const lightRef = useRef();

  const { scene } = useThree();

  useLayoutEffect(() => {
    var l = findObjectStartsWithKey(LightName, scene);
    if (l) {
      lightRef.current = light;
    } else {
      var target = findObjectStartsWithKey("Brazing_lighttarget", scene);

      var light = new PointLight(new Color("#ff3300"), 0);

      // light.add(debugSphere);
      light.position.copy(target.position);
      light.name = LightName;
      light.distance = 2.5;
      light.decay = 1;
      target.add(light);
      light.position.copy(new Vector3());

      lightRef.current = light;
    }
  }, [scene]);

  useLayoutEffect(() => {
    var workpiece = findObjectStartsWithKey("ME_Brazing_Workpiece", scene);
    var materialClone = workpiece.material.clone();
    // var materialClone = new MeshStandardMaterial();

    materialClone.uniforms = {
      uHeat: {
        value: 0.0,
      },
      uHeatFallof: {
        value: 0.9,
      },
      ...materialClone.uniforms,
    };

    materialClone.onBeforeCompile = (s) => {
      s.uniforms.uHeat = {
        value: 0.0,
      };
      s.uniforms.uHeatFallof = {
        value: 0.9,
      };
      s.uniforms.uHardened = {
        value: 0.0,
      };
      s.fragmentShader = `${fragmentShaderAddition}\n${s.fragmentShader}`;
      s.fragmentShader = s.fragmentShader.replace(`#include <color_fragment>`, ``);
      s.fragmentShader = s.fragmentShader.replace(`#include <dithering_fragment>`, fragmentShaderReplacement);

      materialClone.userData.shader = s;
    };

    materialRef.current = materialClone;
    workpiece.material = materialClone;
  }, [scene]);

  useSpring({
    from: { glow: 0 },
    to: { glow: glowing ? 1 : 0 },
    config: { duration: 3500 },
    delay: glowing ? 1000 : 1,
    onRest: () => {
      if (!glowing && lightRef.current) lightRef.current.visible = false;
    },
    onStart: () => {
      if (glowing && lightRef.current) lightRef.current.visible = true;
    },
    onChange: ({ value }) => {
      if (materialRef.current) {
        materialRef.current.userData.shader.uniforms.uHeat.value = value.glow * 3;
      }
      if (lightRef.current) {
        lightRef.current.intensity = value.glow * 1.8;
      }
    },
  });

  return null;
};

export default Brazing;
